export interface PageResponse<T> {
    content: T[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export function wrapInPageResponse<T>(content: T[]): PageResponse<T> {
    return {
        content,
        empty: false,
        first: true,
        last: true,
        number: 0,
        numberOfElements: content.length,
        size: content.length,
        totalElements: content.length,
        totalPages: 1
    };
}
